// extracted by mini-css-extract-plugin
export default {"root":"mkCvVn","text":"OiRUCf","isMobile":"sxr07K","icon":"YQWluP"};